// extracted by mini-css-extract-plugin
module.exports = {"text-translator":"text-translator--2bUa716U"};